import { EntryField } from '../util/common/entryField';
import { CalendarDateEntryBody } from './calendarDateEntryBody';
import { CalendarDateEntryHeader } from './calendarDateEntryHeader';
import { CalendarDateEntryNote } from './calendarDateEntryNote';
import { CalendarTimeEntryField } from './calendarTimeEntryField';

interface CheckInDateEntryFieldProps {
  props: {
    header: {
      label: string;
      onPrev: () => void;
      onNext: () => void;
    };
    date: {
      dateLabel: string;
      selectStyle: string;
      reserveStyle: string;
      onClick: () => void;
    }[][];
    time: {
      dateLabel: string;
      onClick: () => void;
      selectStyle: string;
    }[];
  };
}
export const CheckInDateEntryField = ({
  props: {
    header: calendarHeader,
    date: calendarDateItemList,
    time: timeItemList,
  },
}: CheckInDateEntryFieldProps) => {
  return (
    <div className={'check-in-date-entry-field'}>
      <EntryField label={'ご希望の入庫日を選択してください'} required>
        <div className={'calendar-date-field'}>
          <CalendarDateEntryHeader header={calendarHeader} />
          <CalendarDateEntryBody dateItemList={calendarDateItemList} />
          <CalendarDateEntryNote />
        </div>
      </EntryField>
      <EntryField label={'ご希望の時間を選択してください'} required>
        <CalendarTimeEntryField timeList={timeItemList} />
      </EntryField>
    </div>
  );
};
